import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const StudentCouncil = () => {

    const images = [    
    {
      src: '/images/studentcouncil/studentcouncil-1.png',
      alt: 'Modern classroom with technology',
    },
    {
      src: '/images/studentcouncil/studentcouncil-2.png',
      alt: 'Students collaborating in classroom',
    },
    {
      src: '/images/studentcouncil/studentcouncil-3.png',
      alt: 'Interactive learning session',
    },
    {
      src: '/images/studentcouncil/studentcouncil-4.png',
      alt: 'Digital classroom setup',
    },
    {
      src: '/images/studentcouncil/studentcouncil-6.png',
      alt: 'Digital classroom setup',
    },
    {
      src: '/images/studentcouncil/studentcouncil-6.png',
      alt: 'Digital classroom setup',
    }
  ];


  return (
    <>
       <Breadcrumb 
            pageTitle="Student Council"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Student Council" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
       <section className="space-ptb">
         <div class="container">
                <div className="row align-items-center">
                    <div className="col-md-12">
                        <div className="section-title mb-4">
                            <h2 className="title">
                            <span className="text-primary">Student Council</span>
                            </h2>
                             <div className="curved-line mx-auto mt-3"></div>
                        </div>
                    </div>
                </div>       
     
                <div className='smart-classroom'>
                        <div className="image-gallery">
                            {images.map((image, index) => (
                            <div className="image-item" key={index}>
                                <img src={image.src} alt={image.alt} />
                            </div>
                            ))}
                        </div>          
                </div> 
          </div>
      </section>

      <style jsx>{`       
        .smart-classroom {
          padding: 20px 20px;
          background: #f8f8f8;
          margin-bottom:40px;
          border-radius:5px;
        }

        .image-gallery {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 20px;
          margin-bottom: 30px;          
        }

        .image-item img {
          width: 100%;
          height: 260px;
          object-fit: cover;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          transition: transform 0.3s ease;
        }

        .image-item img:hover {
          transform: scale(1.05);
        }


        .description-text {
          font-size: 1rem;
          line-height: 1.6;
          color: #4a5568;
          margin-bottom: 15px;
          text-align: justify;
        }

        .description-text:last-child {
          margin-bottom: 0;
        }

        @media (max-width: 768px) {          

          .image-gallery {
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 15px;
          }

          .image-item img {
            height: 150px;
          }

          .description-text {
            font-size: 0.95rem;
            text-align: left;
          }
        }

        @media (max-width: 480px) {    
          .image-gallery {
            grid-template-columns: 1fr;
          }

          .image-item img {
            height: 120px;
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .smart-classroom {
          animation: fadeIn 0.5s ease-out;
        }

        .image-item img:focus {
          outline: 2px solid #2c5282;
          outline-offset: 2px;
        }
      `}</style>
    </>
  )
}

export default StudentCouncil
